<div id="radioGEN-div" class="demo-full-width margin-top" [formGroup]="group" class="custom-form-field">
  <label id="radioGEN-div-label" class="radio-label-padding">{{ field.displayName }}:</label>
  <mat-radio-group id="radioGEN-div-mat-radio" [formControlName]="field.name">
    @for (item of field.options; track item) {
      <mat-radio-button id="radioGEN-div-mat-radio-button" [value]="item.value">{{ item.value }}</mat-radio-button>
    }
  </mat-radio-group>
</div>
